import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { SCREENS_INITIAL_STATE, ScreensState } from './screens.model';
import { CallStateEnum } from '@shared/models/call-state.model';
import { SnackbarType } from '@shared/models/app-snackbar.model';
import useSnackbarStore from '@store/snackbar-store/snackbar.store';
import { withCallState } from '@shared/store-features/call-state-feature';
import {
  createDeviceScreen,
  deleteDeviceScreen,
  deleteDeviceScreenMany,
  editDeviceScreenRow
} from '@shared/api/digital-signage/screens-api';

const { showSnackbar } = useSnackbarStore.getState();

const useScreensStore = create<ScreensState>()(
  devtools(
    (set, getState) => ({
      ...SCREENS_INITIAL_STATE,
      ...withCallState(getState),

      createRow: async ({ data, state, handleClose }) => {
        set({ callState: CallStateEnum.Loading });
        try {
          const createdScreen = await createDeviceScreen(data);
          set({ callState: CallStateEnum.Loaded });
          handleClose?.();
          state?.setApiFunctionAndFetchData?.(state.apiFunction);
          showSnackbar(
            'snackbar_success_digital_signage_screens_text',
            SnackbarType.Success
          );

          return createdScreen;
        } catch (error) {
          set({ callState: CallStateEnum.Error });
          if (error instanceof Error) {
            showSnackbar(error.message, SnackbarType.Error);
          }

          throw error;
        }
      },
      editRow: async ({ data, id, state, handleClose }) => {
        set({ callState: CallStateEnum.Loading });
        try {
          await editDeviceScreenRow(data, id);
          set({ callState: CallStateEnum.Loaded });
          handleClose?.();
          state.setApiFunctionAndFetchData(state.apiFunction);
          showSnackbar(
            'snackbar_update_digital_signage_screens_text',
            SnackbarType.Success
          );
        } catch (error) {
          set({ callState: CallStateEnum.Error });
          if (error instanceof Error) {
            showSnackbar(error.message, SnackbarType.Error);
          }
        }
      },
      deleteRow: async ({ id, state, handleClose }) => {
        set({ callState: CallStateEnum.Loading });
        try {
          if (id instanceof Array) {
            await deleteDeviceScreenMany(id);
          } else {
            await deleteDeviceScreen(id);
          }
          set({ callState: CallStateEnum.Loaded });
          handleClose?.();
          state.setApiFunctionAndFetchData(state.apiFunction);
          showSnackbar(
            'snackbar_delete_digital_signage_screens_text',
            SnackbarType.Success
          );
        } catch (error) {
          set({ callState: CallStateEnum.Error });
          if (error instanceof Error) {
            showSnackbar(error.message, SnackbarType.Error);
          }
        }
      }
    }),

    { name: 'ScreensStore' }
  )
);

export default useScreensStore;
